import { State } from "../../types";

export type ClearActiveDataPointAction = Readonly<{
  type: "CLEAR ACTIVE DATA POINT";
}>;

export const clearActiveDataPoint = (state: State, _action: ClearActiveDataPointAction): State => {
  return {
    ...state,
    activeValue: "",
  };
};
